import { useCallback, useEffect, useRef, useState } from 'react'
import AlertDialog from '../popupComp/AlertDialog';
import LoadingScreen from '../loadingScreenComp/LoadingScreen';
import { useLocation } from 'react-router-dom';
import { IconCheckSuccess, IconWarning } from '../iconSet/IconSet';
import { APIGetDetails, APIGotToNext, APIRequestClickNext, APIRequestDetails, APIResponseDetails, APIResponseTutorialDetails } from './TutorialService';
type TutorialPropsType = {
   
}

const Tutorial = (props: TutorialPropsType) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const [moduleTitle, setModuleTitle] = useState<string>('N/A')
    const [totalPages, setTotalPages] = useState<number>(0)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [nextPage, setNextPage] = useState<number>(-1)
    
    const moduleRef = useRef<string>('')
    const [htmlContent, setHtmlContent] = useState<string>('')
    //const [tutorialType, setTutorialType] = useState<TutorialType>('video')
    const [tutorialId, setTutorialId] = useState<string>('')
    //const [moduleId, setModuleId] = useState<string>('')
    const [currentStatus, setCurrentStatus] = useState<boolean>(false)
    const [validUntil, setValidUntil] = useState<string | null>(null)
    const [isRequired, setIsRequired] = useState<boolean>(false)

    // Page complete or not state
    const [isComplete, setIsComplete] = useState<boolean>(false)

    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const location = useLocation()


    const [moduleId, setModuleId] = useState<string>('')
    const responseRef = useRef<APIResponseDetails>()
    const [response, setResponse] = useState<APIResponseDetails>()
    const [selectPage, setSelectPage] = useState<APIResponseTutorialDetails>()
    const [tutorials, setTutorials] = useState<APIResponseTutorialDetails[]>()
    const selectPageRef = useRef<APIResponseTutorialDetails>()
    const [isFinal, setIsFinal] = useState<boolean>(false)

    
    const formatLocalDateTime = (isoString: string): string => {
        const d = new Date(isoString);
        const pad = (n: number) => n.toString().padStart(2, "0");
      
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
            `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      }

    useEffect(() => {
        const parameters = new URLSearchParams(location.search)
        const moduleParam = parameters.get('module') || ''
        moduleRef.current = moduleParam

        setModuleId(moduleParam)

        // const requestBody: APIRequestPageDetails = {
        //     moduleId: moduleRef.current
        // }

        // const initialModuleLoad = async () => {
        //     setIsLoading(true)
            
        //     const response = await APIGetPageDetails(requestBody)
    
        //     if (response.status)
        //     {
        //         setModuleTitle(response.data?.moduleName || 'N/A')
        //         setTotalPages(response.data?.totalPages || 0)
        //         setCurrentPage(response.data?.currentPage || 0)
        //         setHtmlContent(response.data?.htmlContent || 'N/A')
        //         setTutorialType(response.data?.type || 'video')
        //         setTutorialId(response.data?.tutorialId || 'N/A')
        //         setNextPage(response.data?.nextPage || -1)
        //         setModuleId(response.data?.moduleId || 'N/A')
        //         setCurrentStatus(response.data?.status || false)
        //         setValidUntil(response.data?.validUntil || null)
        //     }
    
        //     setIsLoading(false)
        // }

        // initialModuleLoad()
    }, [location.search])

    // Video setup
    const lastTimeRef = useRef<number>(0)
    const [progress, setProgress] = useState<number>(0)
    const [isSkipped, setIsSkipped] = useState<boolean>(false)

    const [videoLoaded, setVideoLoaded] = useState(false);

    // Video playback controls
    useEffect(() => {
        const video = videoRef.current
        if (!video || !videoLoaded || !isRequired) return
        //console.log("INSIDE")
        // Handle time update
        const handleTimeUpdate = () => {
            const current = video.currentTime
            const duration = video.duration || 0

            setProgress((current / duration) * 100)

            lastTimeRef.current = current;
        }

        // Handle video end
        const handleVideoEnd = () => {
            
            if (!isSkipped) 
            {
                setIsComplete(true)
            }
        }

        video.addEventListener("timeupdate", handleTimeUpdate)
        video.addEventListener("ended", handleVideoEnd)

        return () => {
            video.removeEventListener("timeupdate", handleTimeUpdate)
            video.removeEventListener("ended", handleVideoEnd)
        }

    }, [isSkipped, videoLoaded, isRequired])


    const lastProgressRef = useRef<number>(0)
    const firstSkipProgress = useRef<number>(0)
    useEffect(() => { 
        if ((progress - lastProgressRef.current) > 2)
        {
            if (!isSkipped) firstSkipProgress.current = lastProgressRef.current
            setIsSkipped(true)
        }

        if (progress < firstSkipProgress.current)
        {
            setIsSkipped(false)
        }
        lastProgressRef.current = progress
    }, [progress])

    // Set progress bar width
    const getProcessWidth = (): string => {
        if (!totalPages || totalPages <= 1) return '0%'

        const onePart: number = 100 / (totalPages -1)
        const width: number = onePart * (currentPage - 1) 

        return `${width}%`
    }

    useEffect(() => {
        if (tutorialId === '' || !isRequired) return

        const video = document.getElementById(tutorialId);
        //console.log("VIDE")
        if (!video) return;

        videoRef.current =  video as HTMLVideoElement
        if (!videoRef.current) return
    
        const handler = () => setVideoLoaded(true);
        videoRef.current.addEventListener("loadeddata", handler);
    
        return () => {
            if (!videoRef.current) return
            videoRef.current.removeEventListener("loadeddata", handler)
        }
    }, [tutorialId, isRequired]);

    // Handle next click button
    const handleNextClick = useCallback(async () => {
        if (!selectPageRef.current) return

        const body: APIRequestClickNext = {
            tutorialId: selectPageRef.current.tutorialId
        }

        /* if (selectPageRef.current.type === 'quiz')
        {
            handleQuizNextClick()
            return
        } */

        try
        {
            setIsLoading(true)
            const response = await APIGotToNext(body)

            if (response.status)
            {
                window.location.reload()
            }
        }
        catch (error)
        {
            console.error(error)
        }
        finally
        {
            setIsLoading(false)
        }
    }, [moduleId])

    /* const handleQuizNextClick = async () => {
        if (!moduleId && !tutorialId) return

        const body: APIRequestQuizAnswer = {
            moduleId: moduleId,
            tutorialId: tutorialId
        }

        const response = await APIGetQuizAnswers(body)

        if (response.status)
        {
            let allCorrect = true
            for (let i = 0; i < response.data.length; i++)
            {
                const questionId = response.data[i].question;
                const correctAnswer = response.data[i].answer;

                const selectedInput = document.querySelector<HTMLInputElement>(`input[name="${questionId}"]:checked`)
                if (!selectedInput) 
                {
                    allCorrect = false;
                    break;
                }

                if (selectedInput.value !== correctAnswer) 
                {
                    allCorrect = false;
                    break;
                }
            }

            if (allCorrect) 
            {
                console.log("All answers are correct ✅")
                return true;
                //handleNextClick()
            } 
            else 
            {
                console.log("Some answers are incorrect ❌")
                return false
            }
        }
    } */

    useEffect(() => {
        if (!moduleId) return

        const loadDate = async () => {
            const body: APIRequestDetails = {
                moduleId: moduleRef.current
            }

            try
            {
                setIsLoading(true)
                const response = await APIGetDetails(body)

                if (response.status)
                {
                    responseRef.current = response.data!
                    setResponse(response.data!)
                    setTotalPages(response.data?.tutorials.length!)
                    setModuleTitle(response.data?.moduleName!)

                    //console.log("RESPONSE -> ", response)

                    const hasFalse = responseRef.current.tutorials.filter(item => item.status === false)
                    if (hasFalse.length === 1)
                    {
                        setIsFinal(true)
                    }
                    else
                    {
                        setIsFinal(false)
                    }

                    const filteredTutorials = responseRef.current.tutorials.sort((a, b) => a.step - b.step)

                    const filteredStatus = filteredTutorials.filter(item => item.status === true)

                    if (filteredStatus.length === filteredTutorials.length)
                    {
                        const lastPage = filteredTutorials[filteredTutorials.length - 1]
                        setHtmlContent(lastPage.html!)
                        setSelectPage(lastPage)
                        setTutorials(filteredTutorials)
                        selectPageRef.current = lastPage
                    }
                    else 
                    {
                        for (let i = 0; i < filteredTutorials.length; i++)
                        {
                            if (filteredTutorials[i].status)
                            {
                                continue
                            }
                            else 
                            {
                                setHtmlContent(responseRef.current.tutorials[i].html!)
                                setSelectPage(responseRef.current.tutorials[i])
                                setTutorials(filteredTutorials)
                                selectPageRef.current = responseRef.current.tutorials[i]
                                setCurrentPage(i + 1)
                                setIsRequired(responseRef.current.tutorials[i].isRequired)
                                setTutorialId(responseRef.current.tutorials[i].tutorialId)
                                break
                            }
                        }
                    }
                }
            }
            catch (error)
            {
                console.error(error)
            }
            finally{
                setIsLoading(false)
            }
            
        }

        loadDate()
    }, [moduleId])

    const handlePageClick = (item: APIResponseTutorialDetails, index: number) => {
        if (item.status || selectPage?.tutorialId === item.tutorialId || currentPage === index + 1)
        {
            setHtmlContent(item.html)
            setSelectPage(item)
        }
    }


    
    return (
        <div className={`container-wrapper`}>
            <span className={`title`}>{moduleTitle} Module</span>

            {totalPages > 0 ? (
                <div className='tutorial-wrapper'>
                    {/* <div className='progress-bar' style={{ justifyContent: totalPages === 1 ? 'flex-end' : 'space-between' }}>
                        {Array.from({ length: totalPages }, (_, i) => i).map((count, index) => (
                            <div className={`page ${(count + 1 === currentPage && !currentStatus) ? 'active' : ((count + 1) < currentPage || currentStatus) ? 'done' : ''}`} key={index}>{count + 1}</div>
                        ))}
                        <div className='status-bar'></div>
                        <div className='status-bar-top' style={{ width: `${totalPages === 1 ? 'calc(100% - 2rem)' : currentPage === 2 ? `calc(${getProcessWidth()})` : `calc(${getProcessWidth()} - 2rem)`}` }}></div>
                    </div> */}
                    <div className='progress-bar' style={{ justifyContent: totalPages === 1 ? 'flex-end' : 'space-between' }}>
                        {tutorials?.map((item, index) => (
                            <div key={index} className={`page ${item?.status ? 'done' : selectPage?.tutorialId === item.tutorialId ? 'active' : ''}`} onClick={(e) => handlePageClick(item, index)} style={{ cursor: item.status || selectPage?.tutorialId === item.tutorialId ? 'pointer' : 'default', border: selectPage?.tutorialId === item.tutorialId ? 'solid 0.2rem var(--color-main-blue)' : 'none'}}>
                                {index + 1}
                            </div>
                        ))}
                        <div className='status-bar'></div>
                        <div className='status-bar-top' style={{ width: `calc(100% - 2rem)` }}></div>
                    </div>

                    {/* Page wrapper */}
                    <div className='page-wrapper'>
                        {/* Notification wrapper */}
                        <div className='notification-wrapper'>
                            {isSkipped && (
                                <div className='error'>
                                    <div className='icon'>
                                        <IconWarning width="100%" color="var(--color-main-red)" />
                                    </div>
                                    <span>You skipped the tutorial video. You cannot complete the tutorial without watching it. Please go back to the point you skipped and watch the full video without skipping.</span>
                                </div>
                            )}
                            {currentStatus && (
                                <div className='success'>
                                    <div className='icon'>
                                        <IconCheckSuccess width="100%" color="var(--color-main-green)" />
                                    </div>
                                    <span>You are successfully completed '{moduleTitle}' module. This is valid until {formatLocalDateTime(validUntil!)}</span>
                                </div>
                            )}
                        </div>

                        {/* Template body */}
                        <div className='template-body'>
                            <div dangerouslySetInnerHTML={{__html: htmlContent}} style={{display: 'contents'}} />
                        </div>

                        {/* Button wrapper */}
                        {!selectPage?.status && (
                            <div className='button-wrapper'>
                                {isFinal ? (
                                    <button className='finish' disabled={isRequired && isComplete ? true : false} onClick={(e) => handleNextClick()}>Finish</button>
                                ) : (
                                    <button className='next' disabled={isRequired && !isComplete ? true : false} onClick={(e) => handleNextClick()}>Next</button>
                                )}
                                
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className='empty-tutorial-pages'>
                    <span>Sorry no any training available for you now under module {moduleTitle}</span>
                </div>
            )}
            
            {alertDialogState && (
                <AlertDialog
                    title={alertTitle}
                    description={alertDescription}
                    windowState={alertDialogState}
                    setWindowState={setAlertDialogState}
                    function={alertYesCallback}
                    okFunction={alertOkCallback}
                />
            )}
            {isLoading && (
                <LoadingScreen />
            )}

        </div>
    )
}

export default Tutorial